angular.module('directives.recovery')
    .directive('passwordRecovery', ['$state', 'PortalApi', 'Localization', Cntrl]);

function Cntrl($state, PortalApi, Localization) {

    return {
        restrict: 'A',
        template: require('../templates/index.html'),
        link: postLink
    };

    function postLink($scope, el, attrs, controller) {
        $scope.recoveryStep = '';
        $scope.recPassForm = {};

        $scope.init = function (activeStep) {
            $scope.registrationStep = 'login';
        };

        $scope.sendCode = function () {
            $scope.activeSliderFormPreLoader(true);

            PortalApi.sendRecoveryPassCode($scope.recPassForm.login).then(
                function (response) {

                    if (response.status !== 'ok') {
                        Localization.notifyTemplate('error', 'NOTIFICATION.LOGIN_RECOVER.NOT_FOUND', 5, true);
                    }
                    else{
                        Localization.notifyTemplate('success', 'NOTIFICATION.LOGIN_RECOVER.SEND', 5, true);
                    }

                    $scope.registrationStep = 'passwordChange';
                },
                function () {
                    Localization.notifyTemplate('error', 'NOTIFICATION.LOGIN_RECOVER.SEND_ERROR', 5, true);
                }
            ).finally(function () {
                $scope.activeSliderFormPreLoader();
            });
        };

        $scope.changePassword = function () {
            $scope.activeSliderFormPreLoader(true);

            PortalApi.changePassword($scope.recPassForm).then(
                function (response) {

                    if (response.status !== 'ok') {
                        Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.WRONG_CODE', 5, true);
                    }
                    else{
                        Localization.notifyTemplate('success', 'NOTIFICATION.SUCCESS.PASSWORD_SUCCESS', 5, true);
                    }

                    $scope.toggleSliderForm('', true);
                },
                function () {

                    Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.OOPS_ERROR', 5, true);

                }
            ).finally(function () {
                $scope.activeSliderFormPreLoader();
            });
        };

        $scope.init();
    }
}

module.exports = 'directives.authentication';


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/passwordRecovery/directives/passwordrecovery.directive.js
 ** module id = 191
 ** module chunks = 1
 **/